export const useStyles = {
  control: (base, state) => ({
    ...base,
    fontSize: "1.3rem !important",
    color: "#000",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "1.3rem !important",
  }),
};

export const customStyle = {
  control: (base, state) => ({
    ...base,
    fontSize: "1.3rem !important",
    color: "#000",
    width: "310px",
    '@media (max-width: 1200px)': {
      width: "100%",
    },
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "1.3rem !important",
  }),
  menuList: (base) => ({
    ...base,
  }),
};
